require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./muses-et-expositions-1-8-0.json") })
        }
      }, "path---muses-et-expositions-1-8-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---muses-et-expositions-1-8-0!./.cache/json/muses-et-expositions-1-8-0.json
// module id = 506
// module chunks = 231608221292675